/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import UsersTabContent from './UsersTabContent'

interface IUsersData {
    id?: any | null;
    firstName: string;
    lastName?: string | null | undefined;
    email: string;
    password: string;
    clientId: number;
    passwordResetKey?: any | null;
    resetKeySentOn?: any | null;
    isDeleted: boolean;
    isActive: boolean;
    timeZone?: any | null;
    phone?: any | null;
    roleId?: any | null;
    createdBy: string;
    createdOn: string;
    createdSource: string;
    modifiedBy?: any | null;
    modifiedOn?: any | null;
    modifiedSource?: any | null;
    //For user role
    hasRole: boolean;
    name: string;
    userID:any;
    hasWebAccess: boolean;
    hasAPIAccess : boolean;
    roleName: string | null;
  }
  
// interface SelectedUserId {
//     id: number;
//   }

interface UsersTabProps {
    page: string;
    roleData: IUsersData[];
    closeModal: () => void;
    onUserSelect: (userId: number, checked: boolean) => void;
    selectedUserIds: number[];
    setSelectedUserIds: React.Dispatch<React.SetStateAction<number[]>>;
}

function UsersTab({  roleData, onUserSelect, selectedUserIds }: UsersTabProps):JSX.Element {
    // use roleData here to render the user details
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    // useEffect(() => {
    //     let ids:any = []
    //     roleData.map((userData:any) => {
    //         if(userData.hasRole) {
    //             ids.push({"id": userData.userID})
    //         }
    //     })
    //     setSelectedUserIds(ids);
    // }, [roleData])

    const onItemSelect = (userId: number, checked: boolean): void => {
        // if (checked) {
        //     setSelectedUserIds((prevState:any) => [...prevState, {id: userId}]);
        // } else {
        //     const ids = selectedUserIds.filter((id: any) => id.id !== userId)
        //     setSelectedUserIds(ids);
        // }
        onUserSelect(userId, checked);
    };
    
    return (
        <div>
            {/* Render UsersTabContent for each user */}
            <div className='px-[16px] pt-[10px] mb-[60px]'>
                {roleData.map((userData, index) => (
                    <UsersTabContent 
                        key={index} 
                        userData={userData} 
                        index={index} 
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        onItemSelect={(userData: any, checked: boolean) => onItemSelect(userData.id, checked)} 
                        selected={selectedUserIds.includes(userData.userID)}
                        selectedUserIds={selectedUserIds}
                        selectAllChecked={selectAllChecked} // Pass selectAllChecked prop
                    />
                ))}
            </div>
        </div>
    );
}

export default UsersTab;